import { busService } from "../../bus";
import { DisableAllGesturesMessage, DisableGestureMessage, SetEnabledGesturesMessage } from "flavr-common";
const moveGestureConnection = busService.connection("ScriptMoveGestureManager");
export class ScriptMoveGestureManager {
    static enableGesture(gesture, enable) {
        moveGestureConnection.send(new DisableGestureMessage(gesture, !enable));
    }
    static enableGestures(gestures) {
        moveGestureConnection.send(new SetEnabledGesturesMessage(gestures));
    }
    static enableAllGestures(enable) {
        moveGestureConnection.send(new DisableAllGesturesMessage(enable));
    }
}
